import { createFileRoute } from '@tanstack/react-router';
import { RatesSearchPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/')({ component: RatesSearchPage });
